/**
 * Ant Design theme tokens — dark blue palette
 * Light: navy primary, slate backgrounds
 * Dark: blue accent, slate backgrounds
 * No green/teal per user decision.
 */

import { theme } from 'antd';

export const lightThemeTokens = {
  colorPrimary: '#1e3a5f',
  colorPrimaryHover: '#2d4a6f',
  colorPrimaryActive: '#172d4a',
  colorSuccess: '#22c55e',
  colorError: '#ef4444',
  colorWarning: '#f59e0b',
  colorInfo: '#3b82f6',
  colorBgLayout: '#f1f5f9',
  colorBgContainer: '#ffffff',
  colorBgElevated: '#ffffff',
  colorText: '#1e293b',
  colorTextSecondary: '#64748b',
  colorBorder: '#e2e8f0',
};

export const darkThemeTokens = {
  colorPrimary: '#3b82f6',
  colorPrimaryHover: '#60a5fa',
  colorPrimaryActive: '#2563eb',
  colorSuccess: '#22c55e',
  colorError: '#ef4444',
  colorWarning: '#f59e0b',
  colorInfo: '#3b82f6',
  colorBgLayout: '#0f172a',
  colorBgContainer: '#1e293b',
  colorBgElevated: '#334155',
  colorText: '#f1f5f9',
  colorTextSecondary: '#cbd5e1',
  colorBorder: '#334155',
};

/** Returns Ant Design ConfigProvider theme config for given mode */
export const getAntdThemeConfig = (mode) => ({
  algorithm: mode === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
  token: mode === 'dark' ? darkThemeTokens : lightThemeTokens,
});
